import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { FormField } from "@/schemas/type";

interface FormSelectProps {
  field?: FormField;
  placeholder?: string;
  className?: string;
  required?: boolean;
  options?: {
    id?: string;
    label: string;
    value: string;
  }[];
  disabled?: boolean;
}

export default function FormSelect(props: FormSelectProps) {
  return (
    <Select
      value={props.field?.value}
      onValueChange={props.field?.onChange}
      disabled={props.disabled}>
      <SelectTrigger
        className={cn(
          "h-10 w-full rounded border-b border-[#F0F0F0] border-t-0 border-x-0 p-0 text-sm hover:border-[#cc2016] focus:border-[#cc2016] data-[disabled]:bg-[#F7F7F7] data-[placeholder]:text-[#A6A6A6] md:border md:border-[#C2C6CE] md:px-4",
          props.className
        )}>
        <SelectValue
          placeholder={
            <span
              className={cn(
                "after:pl-0.5 after:text-[#CC2016]",
                props.required ? "after:content-['*']" : ""
              )}>
              {props.placeholder}
            </span>
          }
        />
      </SelectTrigger>
      <SelectContent className="bg-white">
        {props.options?.map((option, index) => (
          <SelectItem key={index} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
